/* eslint-disable */
//#Global Imports
import React from "react";
import clsx from "clsx";
import MaterialTable, { MTableBody } from "material-table";
import { Grid, TextField } from "@material-ui/core";
//#end Global Imports

//#local Imports
import Modal from "../../components/ui/Modal";
import Button from "../../components/ui/Button";
import { Header } from "../../components/ui/Header";
import Typography from "../../components/ui/Typography";
import { CloseIcon, Plus, SearchIcon, FilterIcon } from "../../assets/Icons";
import { Axios } from "../../services/axios";
import { Mixpanel } from "../../constants/mixpanel";
//#end Local Imports

const SubVendorMargin = () => {
  const [loader, setLoader] = React.useState(false);
  const baseApi = process.env.REACT_APP_NEW_AUTH_SERVER_ID;
  const tableIcons: any = {
    ResetSearch: React.forwardRef((props, ref: any) => <CloseIcon {...props} ref={ref} />),
    Search: React.forwardRef((props, ref: any) => (
      <SearchIcon {...props} ref={ref} fillColor="#1D1D1D" />
    )),
    Filter: React.forwardRef((props, ref: any) => <FilterIcon {...props} ref={ref} />),
    Add: React.forwardRef((props, ref: any) => <Plus {...props} ref={ref} />),
  };
  const headCells = [
    {
      field: "email",
      title: "Email",
      disablePadding: false,
      render: (rowData: any) => (
        <>
          <label>{rowData.email}</label>
        </>
      ),
    },
    {
      field: "vendorCode",
      title: "Vendor Code",
      disablePadding: false,
      render: (rowData: any) => (
        <>
          <label>{rowData.vendorCode}</label>
        </>
      ),
    },
  ];
  const auth_url = process.env.REACT_APP_AUTH_URL_MERGER;
  const [vendorsData, setVendorsData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [exportData, setExportData] = React.useState([]);
  const [vendorData, setVendorData] = React.useState<any>([]);
  const apiUrl = process.env.REACT_APP_SERVER_ID_MERGER;
  const userKey = localStorage.getItem("userKey");
  const userToken = localStorage.getItem("userToken");
  const [vendorActive, setVendorActive] = React.useState("all");
  const [createVendorOpen, setCreateVendorOpen] = React.useState(false);
  const [showVendorCodeModal, setShowVendorCodeModal] = React.useState(false);
  const [vendorCode, setVendorCode] = React.useState("");
  const [vendorDetails, setVendorDetails] = React.useState({
    vendor_name: "",
    vendor_business_name: "",
    email: "",
    code: "",
    city: "",
    isMaster: false,
    isSubVendor: true,
  });
  const [errorMessage, setErrorMessage] = React.useState("");
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";
  const [currency, setCurrency] = React.useState({
    AED: 0.2,
    AUD: 0.2,
    CAD: 0.2,
    EUR: 0.2,
    GBP: 0.2,
    JPY: 0.2,
    MUR: 0.2,
    NZD: 0.2,
    // SAR: 0.2,
    SGD: 0.2,
    USD: 0.2,
    CHF: 0.2,
  });
  const [charges, setCharges] = React.useState({
    bankFee: 500,
    nostro: 1500,
    hopFee: 250,
  });

  const everestPartner = localStorage.getItem("everestPartner");

  const handleVendorDetails = (value: string, type: string) => {
    setVendorDetails((prevState) => ({
      ...prevState,
      [type]: value,
    }));
  };

  const handleCharges = (value: any, type: any) => {
    setCharges((prevState) => ({
      ...prevState,
      [type]: parseFloat(value),
    }));
  };

  const handleCurrencyMarkUp = (value: any, currency: any) => {
    setCurrency((prevState) => ({
      ...prevState,
      [currency]: parseFloat(value),
    }));
  };

  const handleCreateVendorOpen = () => {
    setCreateVendorOpen(true);
    Mixpanel.track("Add_new_vendor");
  };

  const handleCreateVendorClose = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setCreateVendorOpen(false);
  };

  const addNewVendor = async (e: { preventDefault: () => void }) => {
    Mixpanel.track("confirm_add_new_vendor");
    setLoader(true);
    e.preventDefault();

    const vendorCurrencyMargin = [
      {
        currency: "AED",
        marginValue: currency.AED,
      },
      {
        currency: "AUD",
        marginValue: currency.AUD,
      },
      {
        currency: "CAD",
        marginValue: currency.CAD,
      },
      {
        currency: "EUR",
        marginValue: currency.EUR,
      },
      {
        currency: "GBP",
        marginValue: currency.GBP,
      },
      {
        currency: "JPY",
        marginValue: currency.JPY,
      },
      {
        currency: "MUR",
        marginValue: currency.MUR,
      },
      {
        currency: "NZD",
        marginValue: currency.NZD,
      },
      // {
      //   currency: "SAR",
      //   marginValue: currency.SAR,
      // },
      {
        currency: "SGD",
        marginValue: currency.SGD,
      },
      {
        currency: "USD",
        marginValue: currency.USD,
      },
      {
        currency: "CHF",
        marginValue: currency.CHF,
      },
    ];

    const data = {
      vendor_name: vendorDetails.vendor_name,
      vendor_business_name: vendorDetails.vendor_business_name,
      vendor_email: vendorDetails.email,
      vendor_code: vendorDetails.code,
      city: vendorDetails.city,
      source_vendor: "moneyhop",
      isMaster: vendorDetails.isMaster, //always false
      isSubVendor: vendorDetails.isSubVendor, //always true
      vendorCurrencyMargin: vendorCurrencyMargin,
      vendor_bank_fee: charges.bankFee,
      vendor_nostro_charge: charges.nostro,
      vendor_convenience_fee: charges.hopFee,
    };

    await Axios.post(`${baseApi}/remit/master/${userKey}/createVendor`, data, {
      headers: {
        "Access-Control-Allow-Origin": "true",
        "Content-Type": "application/json",
        Authorization: `${userToken}`,
        "X-Route-To": "authservice",
      },
    })
      .then((response) => {
        const data = response.data;

        if (data.success) {
          setCreateVendorOpen(false);
          setShowVendorCodeModal(true);
          setVendorCode(data.vendorCode);
          setErrorMessage("");
        } else if (data.error) {
          setErrorMessage("*email invalid or already exists");
        } else {
          setErrorMessage("*email invalid or already exists");
        }
      })
      .catch(() => {
        setErrorMessage("*email invalid or already exists");
      })
      .finally(() => setLoader(false));
  };

  async function getVendors() {
    const userKey = localStorage.getItem("userKey");

    await Axios.get(`/remit/master/${userKey}/getSubVendors`, {
      headers: {
        "Access-Control-Allow-Origin": "true",
        "Content-Type": "application/json",
        Authorization: `${userToken}`,
      },
    }).then((response) => {
      setVendorsData(response.data.subVendors);
    });
  }

  React.useEffect(() => {
    if (localStorage.getItem("userKey")) {
      getVendors();
    }
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    createArray();
    setVendorData(vendorsData);
    // eslint-disable-next-line
  }, [loading, vendorsData]);

  const createArray = () => {
    if (loading) {
      setLoading(false);
      if (vendorsData) {
        setExportData([...exportData, ...vendorsData]);
      }
    }
  };

  return (
    <div className="w-full">
      <Header />
      <div className="w-full p-12">
        <div>
          <Grid container>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                className="p-3"
              >
                <Grid>
                  <Button
                    bgColor={vendorActive === "all" ? "!bg-primary-200" : "!bg-secondary-600"}
                    className={clsx(
                      "text-lg font-poppins rounded px-[40px] py-[8px] !mr-5 !text-white",
                    )}
                    onClickHandler={() => {
                      setVendorActive("all");
                      Mixpanel.track("All_Sub_vendor_margin");
                    }}
                  >
                    All
                  </Button>
                </Grid>
                <Grid>
                  <Button
                    bgColor={vendorActive === "active" ? "!bg-primary-200" : "!bg-secondary-600"}
                    className={clsx(
                      "text-lg font-poppins rounded px-[40px] py-[8px] !mr-5 !text-white",
                    )}
                    onClickHandler={() => {
                      setVendorActive("active");
                      Mixpanel.track("Active_Sub_vendor_margin");
                    }}
                  >
                    Active
                  </Button>
                </Grid>
                <Grid>
                  <Button
                    bgColor={vendorActive === "inactive" ? "!bg-primary-200" : "!bg-secondary-600"}
                    className={clsx("text-lg font-poppins rounded px-[40px] py-[8px] !text-white")}
                    onClickHandler={() => {
                      setVendorActive("inactive");
                      Mixpanel.track("Inactive_sub_vendor_margin");
                    }}
                  >
                    Inactive
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <MaterialTable
            title={
              vendorActive === "all"
                ? "Vendor List (ALL)"
                : vendorActive === "active"
                ? "Vendor List (ACTIVE)"
                : "Vendor List (INACTIVE)"
            }
            icons={tableIcons}
            columns={headCells}
            data={
              vendorActive === "all"
                ? vendorData
                : vendorActive === "active"
                ? vendorData?.filter((items: { active: boolean }) => items.active)
                : vendorData?.filter((items: { active: boolean }) => !items.active)
            }
            actions={[
              {
                icon: () => (
                  <Button
                    bgColor="bg-[#C9DFFF]"
                    className="px-[20px] py-[7px] rounded text-secondary-600"
                  >
                    <Plus /> <div className="font-poppins text-lg !ml-2">Add Vendor</div>
                  </Button>
                ),
                tooltip: "Add Vendor",
                isFreeAction: true,
                onClick: () => {
                  handleCreateVendorOpen();
                },
              },
            ]}
            options={{
              search: true,
              filtering: true,
              paging: false,
              // pageSize: 10, // make initial page size
              // pageSizeOptions: [10, 20, 30, 40], // rows selection options
              addRowPosition: "first",
            }}
            components={{
              Body: (props) => (
                <MTableBody
                  {...props}
                  onFilterChanged={(columnId: any, value: any) => {
                    props.onFilterChanged(columnId, value);
                    setTimeout(() => {
                      setExportData(props.renderData);
                    }, 1000);
                  }}
                />
              ),
            }}
          />
        </div>

        <div className="!w-1/2">
          <Modal
            visible={createVendorOpen}
            closeHandler={handleCreateVendorClose}
            modalClass="overflow-auto max-h-[90%]"
            header={
              <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid>
                  <Typography
                    fontStyle={{
                      fontColor: "text-black-700",
                      fontWeight: "font-bold",
                      fontFamily: "font-ssp",
                    }}
                    tagType="span"
                  >
                    Vendor Details
                  </Typography>
                </Grid>
                <Grid>
                  <Typography
                    fontStyle={{
                      fontColor: "text-red-100",
                      fontWeight: "font-bold",
                      fontFamily: "font-ssp",
                    }}
                    tagType="span"
                    className="mr-[250px]"
                  >
                    {errorMessage}
                  </Typography>
                </Grid>
              </Grid>
            }
          >
            <Grid>
              <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item xs={6} className="pr-1 mb-3">
                  <TextField
                    id="vendor_name"
                    name="vendor_name"
                    label="Vendor Name"
                    margin="normal"
                    variant="outlined"
                    fullWidth
                    required
                    value={vendorDetails.vendor_name}
                    onChange={(e) => {
                      handleVendorDetails(e.target.value, "vendor_name");
                    }}
                    inputProps={{ pattern: { specialCharRegExp } }}
                  />
                </Grid>
                <Grid item xs={6} className="pr-1 mb-3">
                  <TextField
                    id="vendor_business_name"
                    margin="normal"
                    name="vendor_business_name"
                    variant="outlined"
                    label="Business Name"
                    fullWidth
                    required
                    value={vendorDetails.vendor_business_name}
                    onChange={(e) => {
                      handleVendorDetails(e.target.value, "vendor_business_name");
                    }}
                    inputProps={{ pattern: { specialCharRegExp } }}
                  />
                </Grid>
                <Grid item xs={6} className="pr-1">
                  <TextField
                    id="email"
                    margin="normal"
                    label="Email"
                    type="email"
                    name="email"
                    variant="outlined"
                    fullWidth
                    required
                    onChange={(e) => {
                      handleVendorDetails(e.target.value, "email");
                    }}
                    value={vendorDetails.email}
                  />
                </Grid>
                <Grid item xs={6} className="pr-1">
                  <TextField
                    id="vendorCode"
                    margin="normal"
                    label="Vendor Code"
                    name="vendorCode"
                    disabled
                    variant="outlined"
                    fullWidth
                    required
                    onChange={(e) => {
                      handleVendorDetails(e.target.value, "code");
                    }}
                    value={vendorDetails.code}
                    inputProps={{ pattern: { specialCharRegExp } }}
                  />
                </Grid>
                <Grid item xs={6} className="pt-3 pr-1">
                  <TextField
                    id="city"
                    margin="normal"
                    label="City"
                    name="city"
                    variant="outlined"
                    fullWidth
                    required
                    onChange={(e) => {
                      handleVendorDetails(e.target.value, "city");
                    }}
                    value={vendorDetails.city}
                    inputProps={{ pattern: { specialCharRegExp } }}
                  />
                </Grid>
              </Grid>

{ everestPartner  ? null : <>
           <Grid className="mt-10">
                <Grid container>
                  <Typography
                    className="text-base font-semibold text-black font-poppins"
                    tagType="span"
                  >
                    MarkUp Table{" "}
                  </Typography>
                  <Typography
                    className="text-base font-medium text-[#707070] font-poppins"
                    tagType="span"
                  >
                    (edit your table according to your currency transaction need)
                  </Typography>
                </Grid>
              </Grid>

              <Grid className="mt-5">
                <Grid container className="p-3 bg-black">
                  <Grid item xs={6}>
                    <Typography
                      fontStyle={{
                        fontColor: "text-black-700",
                        fontWeight: "font-bold",
                        fontFamily: "font-ssp",
                      }}
                      tagType="span"
                    >
                      Currency
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      fontStyle={{
                        fontColor: "text-black-700",
                        fontWeight: "font-bold",
                        fontFamily: "font-ssp",
                      }}
                      tagType="span"
                    >
                      Mark-up
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      className="font-bold font-poppins text-sm text-[#707070]"
                      tagType="span"
                    >
                      AED
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      fullWidth
                      id="outlined-required"
                      type="number"
                      defaultValue={currency.AED ? currency.AED : 0}
                      value={currency.AED}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "AED");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "AED");
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      className="font-bold font-poppins text-sm text-[#707070]"
                      tagType="span"
                    >
                      AUD
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.AUD}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "AUD");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "AUD");
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      tagType="span"
                      className="font-bold font-poppins text-sm text-[#707070]"
                    >
                      CAD
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.CAD}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "CAD");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "CAD");
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      tagType="span"
                      className="font-bold font-poppins text-sm text-[#707070]"
                    >
                      EUR
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.EUR}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "EUR");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "EUR");
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      tagType="span"
                      className="font-bold font-poppins text-sm text-[#707070]"
                    >
                      GBP
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.GBP}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "GBP");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "GBP");
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      tagType="span"
                      className="font-bold font-poppins text-sm text-[#707070]"
                    >
                      JPY
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.JPY}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "JPY");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "JPY");
                      }}
                    />
                  </Grid>
                </Grid>

                {/* <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      tagType="span"
                      className="font-bold font-poppins text-sm text-[#707070]"
                    >
                      MUR
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.MUR}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "MUR");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "MUR");
                      }}
                    />
                  </Grid>
                </Grid> */}

                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      tagType="span"
                      className="font-bold font-poppins text-sm text-[#707070]"
                    >
                      NZD
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.NZD}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "NZD");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "NZD");
                      }}
                    />
                  </Grid>
                </Grid>

                {/* <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      tagType="span"
                      className="font-bold font-poppins text-sm text-[#707070]"
                    >
                      SAR
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.SAR}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "SAR");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "SAR");
                      }}
                    />
                  </Grid>
                </Grid> */}

                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      tagType="span"
                      className="font-bold font-poppins text-sm text-[#707070]"
                    >
                      SGD
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.SGD}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "SGD");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "SGD");
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      tagType="span"
                      className="font-bold font-poppins text-sm text-[#707070]"
                    >
                      USD
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.USD}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "USD");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "USD");
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} className="p-2 bg-[#F3F3F3] text-center">
                    <Typography
                      tagType="span"
                      className="font-bold font-poppins text-sm text-[#707070]"
                    >
                      CHF
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      fullWidth
                      value={currency.CHF}
                      onChange={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "CHF");
                      }}
                      onBlur={(e) => {
                        handleCurrencyMarkUp(e.target.value ? e.target.value : 0, "CHF");
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid className="mt-10">
                <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      className="text-base font-semibold text-black font-poppins"
                      tagType="span"
                    >
                      Bank Fee
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      disabled
                      id="outlined-required"
                      type="number"
                      value={charges.bankFee}
                      onChange={(e) => {
                        handleCharges(e.target.value ? e.target.value : 0, "bankFee");
                      }}
                      onBlur={(e) => {
                        handleCharges(e.target.value ? e.target.value : 0, "bankFee");
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      className="text-base font-semibold text-black font-poppins"
                      tagType="span"
                    >
                      Nostro
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      disabled
                      id="outlined-required"
                      type="number"
                      value={charges.nostro}
                      onChange={(e) => {
                        handleCharges(e.target.value ? e.target.value : 0, "nostro");
                      }}
                      onBlur={(e) => {
                        handleCharges(e.target.value ? e.target.value : 0, "nostro");
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      className="text-base font-semibold text-black font-poppins"
                      tagType="span"
                    >
                      Vendor Fee
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="px-5">
                    <TextField
                      id="outlined-required"
                      type="number"
                      value={charges.hopFee}
                      onChange={(e) => {
                        handleCharges(e.target.value ? e.target.value : 0, "hopFee");
                      }}
                      onBlur={(e) => {
                        handleCharges(e.target.value ? e.target.value : 0, "hopFee");
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              </> 
              }
            </Grid>

            <div className="flex items-center justify-end mt-5">
              <Button
                disabled={
                  !vendorDetails.vendor_name ||
                  !vendorDetails.vendor_business_name ||
                  !vendorDetails.email ||
                  !vendorDetails.city
                }
                bgColor={
                  !vendorDetails.vendor_name ||
                  !vendorDetails.vendor_business_name ||
                  !vendorDetails.email ||
                  !vendorDetails.city
                    ? "bg-[#D7D7D7]"
                    : "bg-[#14B1E7]"
                }
                isLoading={loader}
                className="px-[20px] py-[7px] rounded text-white bg-primary-100"
                onClickHandler={addNewVendor}
              >
                Confirm
              </Button>
            </div>
          </Modal>

          <Modal
            visible={showVendorCodeModal}
            closeHandler={() => {
              setShowVendorCodeModal(false);
              setCreateVendorOpen(false);
              window.location.reload();
            }}
          >
            <div className="pt-4">
              <Typography tagType="h5" className="pb-4 text-lg font-semibold text-success-700">
                Congratulations, You created sub vendor successfully!
              </Typography>{" "}
              <Typography tagType="span" className="pb-4 text-sm text-black">
                *Your vendor code is as below
              </Typography>{" "}
              <div className="flex flex-col justify-center">
                <div className="pb-4">
                  <TextField
                    id="vendorCode"
                    name="vendorCode"
                    margin="normal"
                    variant="outlined"
                    fullWidth
                    required
                    disabled
                    value={vendorCode}
                    inputProps={{ pattern: { specialCharRegExp } }}
                  />
                </div>
                <div className="mx-auto ">
                  <Button
                    className="px-[20px] py-[7px] rounded text-white-300 font-poppins font-semibold"
                    onClickHandler={() => {
                      setCreateVendorOpen(false);
                      window.location.reload();
                    }}
                  >
                    OK
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default SubVendorMargin;
